import { MainNavComponent } from "./components/main-nav/main-nav.component";
import { Routes, RouterModule } from "@angular/router";
import { ModuleWithProviders } from "@angular/compiler/src/core";
import { InicioComponent } from "./components/inicio/inicio.component";
import { PresentacionComponent } from "./components/presentacion/presentacion.component";
import { NgModule } from "@angular/core";
import { Busqueda_dirComponent } from './components/totem/busqueda_dir/busqueda_dir.component';

const appRoutes: Routes = [
  //  {path: '', component: InicioComponent},
  { path: "", component: PresentacionComponent },
  { path: "activate/:token", component: InicioComponent },
  { path: "expedientes", component: MainNavComponent },
  {
    path: "seguimiento_certificados",
    loadChildren: () =>
      import("src/app/components/seguimiento-certificados/seguimiento-certificados.module").then(
        (m) => m.SeguimientoCertificadosModule
      ),
  },
  {
    path: "seguimiento_certificado",
    loadChildren: () =>
      import("src/app/components/seguimiento_certificado/seguimiento_certificado.module").then(
        (m) => m.SeguimientoCertificadoModule
      ),
  },
  {
    path: "bnup",
    loadChildren: () =>
      import("src/app/components/bnup/bnup.module").then((m) => m.BnupModule),
  },
  {
    path: "certificados",
    loadChildren: () =>
      import("src/app/components/solicitud-certificados/solicitud-certificados.module").then((m) => m.SolicitudCertificadosModule),
  },

  {
    path: "inspeccion",
    loadChildren: () =>
      import("src/app/components/inspeccion/inspeccion.module").then(
        (m) => m.InspeccionModule
      ),
  },


  {
    path: "cert",
    loadChildren: () =>
      import("./components/certificados/certificados.routing").then(
        (m) => m.CertificadosRoutingModule
      ),
  },

  {
    path: "inicio",
    loadChildren: () =>
      import("./components/inicio/inicio.routing").then(
        (m) => m.InicioRoutingModule
      ),
  },
  {
    path: "borradores",
    loadChildren: () =>
      import("./components/borradores/borradores.module").then(
        (m) => m.BorradoresModule
      ),
  },


  {
    path: "clave_unica",
    loadChildren: () =>
      import("./components/claveunica/claveunica.routing").then(
        (m) => m.ClaveUnicaRoutingModule
      ),
  },

  {
    path: "formulario",
    loadChildren: () =>
      import("./components/formulario/formulario.routing").then(
        (m) => m.FormularioRoutingModule
      ),
  },
  {
    path: "home",
    loadChildren: () =>
      import("./components/home/home.routing").then((m) => m.HomeRoutingModule),
  },

  {
    path: "menu",
    loadChildren: () =>
      import("./components/menu/menu.routing").then((m) => m.MenuRoutingModule),
  },

  {
    path: "instructions",
    loadChildren: () =>
      import("./components/instructions/instructions.module").then(
        (m) => m.InstructionsModule
      ),
  },

  {
    path: "ventanasUrl",
    loadChildren: () =>
      import("./components/ventanasUrl/ventanasUrl.module").then(
        (m) => m.ventanasUrlModule
      ),
  },
  {
    path: "tramites",
    loadChildren: () =>
      import("./components/tramites/tramites.module").then(
        (m) => m.TramitesModule
      ),
  },
  {
    path: "busqueda-direccion",
    loadChildren: () =>
      import("./components/totem/busqueda-dir.module").then(
        (m) => m.BusquedaDirModule
      ),
  },



  {
    path: "seguimiento-expediente",
    loadChildren: () =>
      import("./components/seguimiento-expediente/seguimiento-expediente.module").then(
        (m) => m.SeguimientoExpedienteModule
      ),
  },

  {
    path: "acta-expediente",
    loadChildren: () =>
      import("./components/acta-expediente/acta-expediente.module").then(
        (m) => m.ActaExpedienteModule
      ),
  },

  {
    path: "404",
    loadChildren: () =>
      import("./components/404/404.module").then((m) => m.NotFoundPageModule),
  },
  {
    path: "**",
    loadChildren: () =>
      import("./components/404/404.module").then((m) => m.NotFoundPageModule),
  }
];

export const appRoutingProviders: any[] = [];
export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes, {
  useHash: true,
});

@NgModule({
  imports: [routing],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule { }
